/**
 * FHA availability — client-safe.
 *
 * FHA is a consumer, owner-occupied residential mortgage, so it is offered only
 * where Simply Approved Mortgages is consumer-licensed for residential
 * mortgage brokerage. The broader 37-jurisdiction footprint on this site is
 * business-purpose investor lending and does NOT extend to FHA.
 *
 * The list is derived from the same licensing data the rest of the site uses,
 * and the server gate fails closed for anything not on it.
 */

import { states } from "@/data/states";
import { CONSUMER_LICENSED_SLUGS } from "@/data/licensed-states";

export type FhaEligibleState = { abbrev: string; name: string; slug: string };

export const FHA_ELIGIBLE_STATES: readonly FhaEligibleState[] = states
  .filter((s) => CONSUMER_LICENSED_SLUGS.has(s.slug))
  .map((s) => ({ abbrev: s.abbrev.toUpperCase(), name: s.name, slug: s.slug }))
  .sort((a, b) => a.name.localeCompare(b.name));

export function isFhaEligibleState(abbrev: string | null | undefined): boolean {
  const a = (abbrev ?? "").toUpperCase();
  return FHA_ELIGIBLE_STATES.some((s) => s.abbrev === a);
}

export const FHA_STATE_BLOCKED_MESSAGE =
  "We arrange FHA residential mortgages only in the states where we hold a consumer mortgage brokerage license. Choose a licensed state, or contact a licensed loan officer about your options.";

export const FHA_ZIP_MISMATCH_MESSAGE =
  "That ZIP code is not in the selected state. Correct the ZIP or the state so the property location matches before pricing.";

export const FHA_STATE_LIST_LABEL = FHA_ELIGIBLE_STATES.map((s) => s.name).join(" and ");
